const firebaseConfig = {
  apiKey: "AIzaSyB3L9aHSLRc8VZch4m9pa8NMcIw1Jn3fIE",
  authDomain: "save-the-redwoods.firebaseapp.com",
  projectId: "save-the-redwoods",
  storageBucket: "save-the-redwoods.appspot.com",
  messagingSenderId: "285383208039",
  appId: "1:285383208039:web:22a76212649674371138c2",
  measurementId: "G-CLDHS0C3CT"
};


export default firebaseConfig;
